import { Person } from 'src/app/people/models/person';
import { IMandrillEmailMessageTemplate } from './mandrillEmailTemplate';

export type DeliveryStatus = 'Bounced' | 'Delivered' | 'Rejected' | 'Queued' | 'TestMode';

/** Filter options for the Message Center. Mirrors EmailMessageDeliveryStatus on the server. */
export const DELIVERY_STATUSES: DeliveryStatus[] = [
  'Delivered',
  'Bounced',
  'Rejected',
  'Queued',
  'TestMode'
];

/** Mirrors MailSettings.MessageType. */
export const MESSAGE_TYPES: string[] = [
  'Team Invitation',
  'Team Email',
  'Lineup Form',
  'Team Survey',
  'Evaluation',
  'Email',
  'Group Email',
  'System Message'
];

export interface IEmailMessage {
  id: string;
  subject: string;
  email: string;
  deliveryStatus: DeliveryStatus;
  canResend: boolean;
  personId?: string;
  teamId?: string;
  teamName?: string;
  applicationId?: string;
  sentOn?: string;
  openedOn?: string;
  clickedOn?: string;
  messageType: string;
  sender: string;
  senderName: string;
  replyTo: string;
  bccAddresses: string[];
  template: IMandrillEmailMessageTemplate;
  reminderId?: string;
}

export interface IEmailMessageContent {
  id: string;
  html?: string | null;
}

export interface IEmailMessageWrite {
  subject: string;
  email: string;
  senderName: string;
  replyTo: string;
}

export enum EmailType {
  Single,
  Bulk,
  TeamInvitationReminder,
  TeamMembers,
  Invitees,
  Invitee,
  Survey,
  TeamForm,
  SurveyReminder,
  EvaluationReminder,
  TeamFormReminder,
  WallCertificate,
  PortalInvitation
}

export enum MessageType {
  Delivered = 'Delivered',
  Scheduled = 'Scheduled'
}
